var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4544px",
    height: "4455px",
    viewBox: "0 0 4544 4455",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 3413.47,
    height: 3170.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: -0.002,
    width: 3413.471,
    height: 3170.412
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: -0.002,
    width: 3413.471,
    height: 3170.412
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: -0.002,
    width: 3413.471,
    height: 3170.412
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0,
    y: -0.002,
    width: 3413.471,
    height: 3170.412
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0,
    y: -0.002,
    width: 3413.471,
    height: 3170.412
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 0,
    y: -0.002,
    width: 3413.471,
    height: 3170.412
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-15",
    x: 0,
    y: -0.002,
    width: 3413.471,
    height: 3170.412
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-17",
    x: 0,
    y: 0.06,
    width: 2405.561,
    height: 2228.292
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-19",
    x: 0,
    y: -0.002,
    width: 3413.471,
    height: 3170.412
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map",
    transform: "translate(2272.000000, 2227.500000) rotate(-330.000000) translate(-2272.000000, -2227.500000) translate(565.000000, 642.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.97,589.376 C826.97,589.376 897.206,390.851 902.853,347.086 C908.501,303.321 964.265,12.498 964.265,12.498",
    id: "Path",
    stroke: "#3F7D32",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.912,140.263 C69.912,140.263 436.265,368.969 465.206,392.263 C494.147,415.557 844.954,574.07 844.954,574.07",
    id: "Path",
    stroke: "#3F7D32",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2885.601,1368.489 C2885.601,1368.489 2882.148,1336.734 2914.618,1335.322 C2947.089,1333.91 3203.324,1401.204 3203.324,1401.204 L3400.971,1453.91",
    id: "Path",
    stroke: "#3F7D32",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2348.322,1802.767 C2348.322,1802.767 2437.082,1915.514 2452.97,2044.028 C2468.859,2172.543 2477.115,2368.734 2445.911,2494.852",
    id: "Path",
    stroke: "#3F7D32",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050.959,1048.092 C2046.007,1091.496 2052.803,1121.946 2092.971,1199.191 C2133.14,1276.436 2207.838,1447.203 2229.023,1496.492 C2250.208,1545.782 2261.442,1611.087 2284.971,1668.498 C2306.18,1720.25 2332.771,1781.705 2332.771,1781.705",
    id: "Path",
    stroke: "#3F7D32",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.088,580.498 C833.269,565.785 833.148,578.392 823.794,595.558 C814.44,612.723 806.397,654.389 799.794,677.44 C793.191,700.491 777.932,744.76 812.5,768.734 C841.676,788.97 858.617,800.264 1009.723,904.771 C1159.006,1008.018 1472.291,1202.403 1800.837,1368.241 C1940.752,1438.865 2188.766,1640.685 2235.413,1685.062 C2282.059,1729.44 2298.142,1728.717 2324.555,1769.179 C2350.968,1809.641 2374.903,1849.367 2432.68,1804.491 C2490.455,1759.615 2584.885,1670.393 2622.854,1646.852 C2660.821,1623.311 2775.728,1507.278 2805.442,1479.323 C2835.156,1451.367 2874.537,1406.548 2883.559,1377.676 C2890.618,1355.087 2883.809,1337.509 2825.206,1318.381 C2766.604,1299.254 2653.055,1289.525 2526.772,1238.028 C2400.489,1186.531 2119.708,1083.07 1948.029,1002.146 C1776.35,921.223 1596.029,866.617 1232.735,717.911 C971.109,610.819 875.088,580.498 875.088,580.498 Z",
    id: "Path",
    stroke: "#3F7D32",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.33,
    mask: "url(#mask-16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 287.000000)",
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,20.557 C20.5,20.557 1117.912,758.439 1238.382,833.734 C1439.234,959.266 2010.147,1246.87 2170.147,1422.91 C2306.393,1572.815 2426.147,1688.322 2371.559,2207.851",
    id: "Path",
    stroke: "#CECECE",
    strokeWidth: 41,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-18)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3203.559,1096.263 C3203.559,1096.263 3180.971,1301.439 2943.794,1606.381 C2869.796,1701.522 2640.953,1935.169 2582.147,2178.146 C2517.913,2443.557 2582.147,2776.734 2748.03,3149.911",
    id: "Path",
    stroke: "#C5EBEF",
    strokeWidth: 41,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-20)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c564efebaa42d8bad946ccd477a45d3b.svg";
export { ForwardRef as ReactComponent };